import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import * as rostersActions from 'features/rosters/duck';
import * as tcEventActions from 'features/tc-event-dashboard/duck';
import RosterService from 'features/rosters/RostersService';
import Modal from 'react-modal';
import { mapRoomsByLocation } from 'features/tc-event-dashboard/selectors';
import { AlertNotice, Input, ModalInfo, MultiRadio } from 'shared/components';
import { find, isEmpty } from 'lodash';
import { TIME_INTERVAL_PDF_REQUEST } from 'shared/constants';
import { toRadioList } from '../helpers';
import './RostersDownload.scss';
import DownloadIcon from 'assets/svgs/downloadArrow.svg';
import InfoIcon from 'assets/svgs/info.svg';

class RostersDownload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      downloadModalOpen: false,
      accom: false,
      checkin: false,
      namesonly: false,
      testDate: '',
      error: '',
      loadingModalOpen: false,
      specialRosterModal: false,
    };

    this.handleDownload = this.handleDownload.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.onChangeTestDate = this.onChangeTestDate.bind(this);
    this.toggleDownloadModal = this.toggleDownloadModal.bind(this);
    this.startDownload = this.startDownload.bind(this);
    this.stopLoadingPDF = this.stopLoadingPDF.bind(this);
    this.toggleSpecialRosterModal = this.toggleSpecialRosterModal.bind(this);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
    clearTimeout(this.timeoutId);
  }

  handleDownload() {
    const { accom, checkin, namesonly, testDate } = this.state;

    const { actions, eventId, nowManagedFlag } = this.props;

    if (!accom && !namesonly && !checkin) {
      this.setState({
        error: this.props.t('rosters.download.error'),
      });
    } else {
      const isNowManaged = nowManagedFlag;
      const params = { accom, checkin, namesonly, isNowManaged };
      if (!isEmpty(testDate)) {
        params.date = testDate;
      }
      actions.getEventRostersPdfUUID(eventId, params).then((result) => {
        if (this.props.errorDownloadUUID) {
          this.setState({
            serverError: 'errors.somethingWentWrong',
          });
          return;
        }

        this.startDownload(result);
        this.intervalId = setInterval(() => {
          this.startDownload(result);
        }, TIME_INTERVAL_PDF_REQUEST);
        this.timeoutId = setTimeout(() => {
          this.stopLoadingPDF(true);
          this.setState({
            serverError: 'errors.somethingWentWrong',
          });
        }, 24 * TIME_INTERVAL_PDF_REQUEST);
      });
    }
  }

  stopLoadingPDF(errorLoading = false) {
    clearInterval(this.intervalId);
    clearTimeout(this.timeoutId);
    this.setState((prevState) => ({
      loadingModalOpen: false,
      accom: errorLoading ? prevState.accom : false,
      checkin: errorLoading ? prevState.checkin : false,
      namesonly: errorLoading ? prevState.namesonly : false,
      testDate: errorLoading ? prevState.testDate : '',
      downloadModalOpen: errorLoading,
    }));
  }

  startDownload(uuid) {
    const { eventId, nowManagedFlag } = this.props;
    const { accom, checkin, namesonly } = this.state;

    this.setState({
      loadingModalOpen: true,
      downloadModalOpen: false,
    });

    const isNowManaged = nowManagedFlag;
    RosterService.getEventRostersPdf(eventId, {
      uuid,
      accom,
      checkin,
      namesonly,
      isNowManaged,
    })
      .then((result) => {
        if (result?.url) {
          const link = document.createElement('a');
          link.href = result.url;
          link.id = 'pdf';
          link.download = '';
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.stopLoadingPDF();
        }
      })
      .catch((error) => {
        if (error.status !== 404) {
          this.stopLoadingPDF(true);
          this.setState({
            serverError: 'errors.somethingWentWrong',
          });
        }
      });
  }

  handleCheck(e) {
    const field = e.target.name;
    this.setState((prevState) => ({
      [field]: !prevState[field],
      error: '',
      serverError: '',
    }));
  }

  onChangeTestDate(e) {
    this.setState({
      testDate: e.target.value,
    });
  }
  setCheckinState() {
    const currentDate = moment(this.props.serverDateTime).format('YYYY-MM-DD');
    const date = this.props.tcEvent.testingEvent.rosterExportPhotoDate;
    const isDatePastOrCurrent = date ? moment(date).isSameOrBefore(currentDate) : false;
    const checkedValue = this.props.nowManagedFlag || isDatePastOrCurrent ? true : false;

    this.setState({ checkin: checkedValue });
  }

  toggleDownloadModal() {
    const { locations } = this.props;
    this.setCheckinState();

    if (!this.state.downloadModalOpen) {
      this.props.actions.getEventExamineeCount(locations);
    }

    this.setState((prevState) => ({
      downloadModalOpen: !prevState.downloadModalOpen,
      accom: prevState.downloadModalOpen ? false : prevState.accom,
      checkin: prevState.downloadModalOpen ? this.state.checkin : prevState.checkin,
      namesonly: prevState.downloadModalOpen ? false : prevState.namesonly,
      testDate: prevState.downloadModalOpen ? '' : prevState.testDate,
      serverError: '',
      error: '',
    }));
  }

  toggleSpecialRosterModal() {
    this.setState((prevState) => ({
      specialRosterModal: !prevState.specialRosterModal,
    }));
  }

  render() {
    const {
      locations,
      tcEvent,
      serverDateTime,
      loadingRosterPDF,
      eventExamineeCount,
      dateFilters,
      nowManagedFlag,
    } = this.props;

    const {
      downloadModalOpen,
      accom,
      checkin,
      error,
      namesonly,
      serverError,
      loadingModalOpen,
      testDate,
      specialRosterModal,
    } = this.state;

    const isSpecialEvent =
      tcEvent.testingEvent?.adminId?.cycleId?.programId?.code === 'actspecial' ? true : false;

    const currentDate = moment(serverDateTime).format('YYYY-MM-DD');
    const isDatePastOrCurrent = (date) => {
      return date ? moment(date).isSameOrBefore(currentDate) : false;
    };

    return (
      <section className="rosters-download-section">
        {!!(
          isDatePastOrCurrent(tcEvent.testingEvent.rosterExportNameDate) ||
          isDatePastOrCurrent(tcEvent.testingEvent.rosterExportPhotoDate)
        ) && (
          <div className="download-roster-btn">
            <button
              className="btn btn-action"
              onClick={isSpecialEvent ? this.toggleSpecialRosterModal : this.toggleDownloadModal}>
              {this.props.t('rosters.download.btnLabel')}
            </button>
          </div>
        )}
        <Modal
          isOpen={loadingModalOpen}
          className="custom-modal loading-modal"
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          onRequestClose={() => {}}>
          <div className="loading-modal-content">
            <div className="text-center pb-3">
              {' '}
              <i className="fa fa-spinner fa-spin" />
            </div>
            <h4 className="text-center">{this.props.t('rosters.download.loadingModalTitle')}</h4>
            <p className="text-center">{this.props.t('rosters.download.loadingModalMessage')}</p>
          </div>
        </Modal>

        {/* Roster for special event */}
        <Modal
          isOpen={specialRosterModal}
          className="modal-info pre-pause-modal width-auto"
          shouldCloseOnOverlayClick={false}
          contentLabel="Modal"
          ariaHideApp={false}>
          <div className="modal-container p-3">
            <h5 className="text-center mt-2">{this.props.t('rosters.specialEventRosterText')}</h5>
            <div className="buttons-container w-25">
              <button className="btn btn-action w-25" onClick={this.toggleSpecialRosterModal}>
                {this.props.t('common.labels.ok')}
              </button>
            </div>
          </div>
        </Modal>

        <ModalInfo
          modalIsOpen={downloadModalOpen}
          closeModal={this.toggleDownloadModal}
          headerTitle="rosters.download.modalTitle"
          onSubmit={this.handleDownload}
          saveLabel="rosters.download.modalBtnLabel"
          loadingButton={loadingRosterPDF}
          iconActionButton={<DownloadIcon />}>
          <div className="download-modal">
            {serverError && (
              <div className="mt-3">
                <AlertNotice type="error" message={this.props.t(serverError)} />
              </div>
            )}
            <AlertNotice
              message={
                nowManagedFlag
                  ? this.props.t('rosters.download.sdModalInfo')
                  : this.props.t('rosters.download.nationalModalInfo')
              }
            />
            <div className="dark-gray ">
              <span className="updated">{this.props.t('rosters.updated')}</span>{' '}
              {tcEvent.lastRegSyncDate && moment(tcEvent.lastRegSyncDate).format('MM.DD.YYYY')}
            </div>

            <h6 className="mt-30">{this.props.t('rosters.download.locationsLabel')}</h6>
            {locations.map((location) => {
              let count = 0;
              let total = 0;
              let assignedStatus = find(eventExamineeCount, {
                locationEventId: location.locationEvent.id,
              });
              assignedStatus &&
                assignedStatus.list.map((elem) => {
                  count += elem.regsAssigned;
                  total += elem.regsCount;
                });

              return (
                <div key={location.id}>
                  <div>{`${location.name}${
                    location.area && location.area.length > 0 && `, ${location.area}`
                  }`}</div>
                  <div className="dark-gray examinee-location-info">
                    {this.props.t('rosters.download.assigned', { count, total })}
                    {count !== total && <i className="fa fa-exclamation-triangle" />}
                  </div>
                </div>
              );
            })}

            <h6 className="mt-30">{this.props.t('rosters.download.rosterOptionsLabel')}</h6>
            <div className="display-flex">
              <div>
                <div className="fw-bold mb-3">
                  {this.props.t('rosters.download.rosterTypeLabel')}
                </div>
                {error && <div className="error">{error}</div>}

                <Input
                  type="checkbox"
                  name="namesonly"
                  id="namesonly"
                  value={namesonly}
                  onChange={this.handleCheck}
                  disabled={!isDatePastOrCurrent(tcEvent.testingEvent.rosterExportNameDate)}
                  required>
                  <label htmlFor="namesonly">
                    {this.props.t('rosters.download.namesonlyLabel')}
                  </label>
                  <InfoIcon
                    className="icons ps-1"
                    data-bs-toggle="popover"
                    data-bs-placement="top"
                    data-bs-trigger="hover"
                    data-bs-html
                    data-bs-content={
                      nowManagedFlag
                        ? this.props.t('rosters.download.sdNamesOnlyInfo')
                        : this.props.t('rosters.download.nationalNamesOnlyInfo')
                    }
                  />
                </Input>
                <Input
                  type="checkbox"
                  name="checkin"
                  id="checkin"
                  value={checkin}
                  onChange={this.handleCheck}
                  disabled={!isDatePastOrCurrent(tcEvent.testingEvent.rosterExportPhotoDate)}
                  required={!nowManagedFlag}>
                  <label htmlFor="checkin">
                    {nowManagedFlag
                      ? this.props.t('rosters.download.sdCheckinLabel')
                      : this.props.t('rosters.download.nationalCheckinLabel')}
                  </label>
                  <InfoIcon
                    className="icons ps-1"
                    data-bs-toggle="popover"
                    data-bs-placement="top"
                    data-bs-trigger="hover"
                    data-bs-content={
                      nowManagedFlag
                        ? this.props.t('rosters.download.sdCheckInInfo')
                        : this.props.t('rosters.download.nationalCheckInInfo')
                    }
                  />
                </Input>

                <Input
                  type="checkbox"
                  name="accom"
                  id="accom"
                  value={accom}
                  onChange={this.handleCheck}
                  disabled={!isDatePastOrCurrent(tcEvent.testingEvent.rosterExportPhotoDate)}
                  required>
                  <label htmlFor="accom">{this.props.t('rosters.download.accomLabel')}</label>
                  <InfoIcon
                    className="icons ps-1"
                    data-bs-toggle="popover"
                    data-bs-placement="top"
                    data-bs-trigger="hover"
                    data-bs-html
                    data-bs-boundary="window"
                    data-bs-content={
                      nowManagedFlag
                        ? this.props.t('rosters.download.sdAccommodationsInfo')
                        : this.props.t('rosters.download.nationalAccommodationsInfo')
                    }
                  />
                </Input>
              </div>

              {tcEvent.rescheduleDate && !isEmpty(dateFilters) && (
                <div>
                  <MultiRadio
                    title={this.props.t('rosters.testDateFilterLabel')}
                    onChange={this.onChangeTestDate}
                    radioList={toRadioList(dateFilters)}
                    checkedValue={testDate}
                    name="assignedList"
                  />
                </div>
              )}
            </div>
          </div>
        </ModalInfo>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    locations: mapRoomsByLocation(state),
    errorDownloadUUID: state.rosters.errorDownloadUUID,
    loadingRosterPDF: state.rosters.loadingRosterPDF,
    eventExamineeCount: state.rosters.eventExamineeCount,
    eventExamineeCountLoading: state.rosters.eventExamineeCountLoading,
    nowManagedFlag:
      state.tcEvent.testCenterCycle.testCenterProgram.testCenter.nowManagedFlag || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...rostersActions,
        ...tcEventActions,
      },
      dispatch
    ),
  };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RostersDownload));

RostersDownload.propTypes = {
  // Props from parent component
  eventId: PropTypes.number.isRequired,
  tcEvent: PropTypes.shape({
    testingEvent: PropTypes.shape({
      rosterExportNameDate: PropTypes.string,
      rosterExportPhotoDate: PropTypes.string,
      adminId: PropTypes.shape({
        cycleId: PropTypes.shape({
          programId: PropTypes.shape({
            code: PropTypes.string,
          }),
        }),
      }),
    }),
    rescheduleDate: PropTypes.string,
  }).isRequired,
  serverDateTime: PropTypes.string,
  dateFilters: PropTypes.array,

  // Props from mapStateToProps
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      rooms: PropTypes.array,
    })
  ),
  errorDownloadUUID: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  loadingRosterPDF: PropTypes.bool,
  eventExamineeCount: PropTypes.object,
  eventExamineeCountLoading: PropTypes.bool,
  nowManagedFlag: PropTypes.bool,

  // Props from mapDispatchToProps
  actions: PropTypes.shape({
    getEventRostersPdfUUID: PropTypes.func.isRequired,
    getEventExamineeCount: PropTypes.func.isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
};
